import { render } from "./TrickVideoCarousel.vue?vue&type=template&id=d4e282ca&scoped=true"
import script from "./TrickVideoCarousel.vue?vue&type=script&lang=js"
export * from "./TrickVideoCarousel.vue?vue&type=script&lang=js"

import "./TrickVideoCarousel.vue?vue&type=style&index=0&id=d4e282ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4e282ca"]])

export default __exports__